<template>
    <v-container fluid grid-list-md>
        <v-layout wrap>
            <v-flex xs12>
                <h3>Ежемесячный отчет по поступлению</h3>
                <v-card
                        width="400px"
                >
                    <v-card-text>
                        <v-text-field
                                type="month"
                                v-model.trim="period"
                                label="Дата начала"
                                :error-messages="requiredErrors('period')"
                                @blur="$v.period.$touch()"
                        ></v-text-field>
                    </v-card-text>
                    <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                            :loading="listLoading.includes('downloadReportAcceptanceAct')"
                            @click.native="downloadReport()"
                    >Сформировать отчет
                    </v-btn>
                </v-card-actions>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'

export default {
  data () {
    return {
      period: null
    }
  },
  mixins: [validationMixin],
  validations: {
    period: { required }
  },
  computed: {
    listLoading () {
      return this.$store.getters['common/listLoading']
    }
  },
  methods: {
    requiredErrors (fieldName) {
      const errors = []
      const field = this.$v[fieldName]
      if (!field.$dirty) return errors
      if (field.hasOwnProperty('required')) {
        !field.required && errors.push('Обязательное поле')
      }
      return errors
    },
    downloadReport () {
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.$store.dispatch('ASReports/downloadReportAcceptanceAct', { period: this.period })
      }
    }
  }
}
</script>
